import React, { useEffect } from "react";
import { useBreadcrumbs } from "@/components/provider/BreadcrumbsProvider";
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePostAuthHubSpotMutation } from "@/store/rest_api";

const HubSpotCallback = () => {
  const { setPage, setSection } = useBreadcrumbs();
  const navigate = useNavigate();
  const [queryParams] = useSearchParams();
  const [postAuthHubSpot, postAuthHubSpotResponse] = usePostAuthHubSpotMutation();

  useEffect(() => {
    setSection("Integrations");
    setPage("HubSpot");
  }, []);

  useEffect(() => {
    const authzCode = queryParams.get("code");
    const integrationId = queryParams.get("state");
    if (authzCode && integrationId) {
      postAuthHubSpot({ code: authzCode, integrationId });
    }
  }, []);

  useEffect(() => {
    if (postAuthHubSpotResponse.isError || postAuthHubSpotResponse.isSuccess) {
      const timer = setTimeout(() => {
        navigate("/integrations");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [postAuthHubSpotResponse.isError, postAuthHubSpotResponse.isSuccess]);

  if (postAuthHubSpotResponse.isSuccess) {
    return <div>Success! Redirecting...</div>;
  }

  if (postAuthHubSpotResponse.isError) {
    return <div>Failure, redirecting... </div>;
  }

  return <div>HubSpot callback</div>;
};

export default HubSpotCallback;
